import React from 'react';
import styled from 'styled-components';
import uuid from 'uuid';

import { InputWithBorder } from 'components/molecules/TextInput';
import { Body2, ButtonText, Icon, OverFlowBody2 } from 'ensightful-koala-ui';

const StyledInputWithBorder = styled(InputWithBorder)`
    min-width: 0px;
    padding-bottom: 0px;
    padding-top: 0px;

    & p {
        margin: 0px;
    }
`;

const StyledText = styled(Body2)`
    font-weight: 400;
    margin-bottom: 1em;
`;

const EmptyPrompt = styled(Body2)`
    color: #616161;
`;

const TableContainer = styled.table`
    display: table;
    width: 100%;
`;
const HeaderContainer = styled.thead`
    display: table-header-group;
`;
const BodyContainer = styled.tbody`
    & tr:nth-child(odd) {
        background-color: #f5f5f5;
    }
`;
const FooterContainer = styled.tfoot`
    display: ${(props) => (props.review ? 'none' : 'table-footer-group')};
    border-top: 1px solid #e0e0e0;
`;

const TableRow = styled.tr`
    vertical-align: middle;
    width: 100%;
    border-top: 1px solid #e0e0e0;
`;

const TableCell = styled.td`
    padding: 16px 8px 16px 8px;
`;

const AddMemberContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    width: fit-content;

    & svg {
        width: 15px;
        height: 15px;
        margin-right: 8px;
    }

    & svg path {
        fill: #6347ff;
    }

    &:hover {
        cursor: pointer;
    }
`;

const NumberTableCell = styled(TableCell)`
    padding: 16px 16px 16px 20px;
    width: 1%;
`;

const InputTableCell = styled(TableCell)`
    width: ${(props) => (props.isWithTeam ? '23%' : '40%')};
`;

const TrashCanTableCell = styled(TableCell)`
    width: 1%;
    padding-right: 16px;

    &:hover {
        cursor: pointer;
    }
`;

const StyledIcon = styled(Icon)`
    display: block;
`;

const RoleTableCell = styled(TableCell)`
    width: 10%;
    &:hover {
        cursor: pointer;
    }
`;

const TableHeader = styled.th.attrs({
    colSpan: 2,
})`
    width: ${(props) => (props.isWithTeam ? '23%' : '40%')};
    padding-top: 1em;
`;

// const TableHeader = styled.th`
//     width: ${(props) => (props.isWithTeam ? '23%' : '40%')};
//     padding-top: 1em;
// `;

const RenderUsers = ({ type = 'student', isWithTeam = false, userList = [], handleInputChange, removeRow }) => {
    return userList.map((user, index) => (
        <TableRow key={user.id}>
            <NumberTableCell>
                <Body2>{index + 1}</Body2>
            </NumberTableCell>
            <InputTableCell isWithTeam={isWithTeam}>
                <OverFlowBody2 maxWidth={'90%'}> {user.email} </OverFlowBody2>
            </InputTableCell>
            <RoleTableCell>
                <Body2 style={{ color: '#757575' }}>{type === 'student' ? 'Student' : 'Instructor'} </Body2>
            </RoleTableCell>
            <TrashCanTableCell>
                <StyledIcon onClick={() => removeRow(user.id)} kind={'trashCan'} size={16} />
            </TrashCanTableCell>
        </TableRow>
    ));
};

const InvitedUserTable = ({
    type,
    userList = [],
    tableType = 'student',
    isWithTeam = false,
    handleInputChange,
    review = false,
}) => {
    const convertInputChanges = (index, key, data) => {
        if (!userList || !userList[index]) return;
        const updatedUserList = userList.map((user, userIndex) => {
            if (index === userIndex) {
                return { ...user, [key]: data };
            }
            return user;
        });
        return handleInputChange(type, updatedUserList);
    };

    const removeRow = (id) => {
        const updatedUserList = userList.filter((user) => user.id !== id);
        return handleInputChange(type, updatedUserList);
    };

    return (
        <TableContainer>
            {userList.length > 0 ? (
                <HeaderContainer>
                    <TableRow>
                        <TableHeader isWithTeam={isWithTeam}>
                            <StyledText> Invitations ({userList.length})</StyledText>
                        </TableHeader>
                    </TableRow>
                </HeaderContainer>
            ) : (
                <EmptyPrompt>Press ‘Enter’ after inputting an email to create an invitation.</EmptyPrompt>
            )}
            <BodyContainer>
                <RenderUsers
                    type={tableType}
                    userList={userList}
                    isWithTeam={isWithTeam}
                    handleInputChange={convertInputChanges}
                    removeRow={removeRow}
                />
            </BodyContainer>
            <FooterContainer review={review}></FooterContainer>
        </TableContainer>
    );
};

export default InvitedUserTable;
